var _ellipse, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 20.5,
    rx: 21,
    ry: 20.5,
    fill: "#FFF4ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.572 16.2237C11.5122 15.7303 11.4823 15.4837 11.511 15.2819C11.5948 14.6943 12.0068 14.213 12.5619 14.0544C12.7525 14 12.9935 14 13.4756 14H28.5244C29.0065 14 29.2475 14 29.4381 14.0544C29.9932 14.213 30.4052 14.6943 30.489 15.2819C30.5177 15.4837 30.4878 15.7303 30.428 16.2237C30.2687 17.5377 30.1891 18.1948 29.9939 18.7377C29.429 20.3094 28.138 21.4846 26.5556 21.8676C26.0089 22 25.3668 22 24.0826 22H17.9174C16.6332 22 15.9911 22 15.4444 21.8676C13.862 21.4846 12.571 20.3094 12.0061 18.7377C11.8109 18.1948 11.7313 17.5377 11.572 16.2237Z",
    stroke: "#FF6600",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19H21.009",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20L12.5 23.02C12.5 26.0747 12.5 27.6021 13.6065 28.551C14.713 29.5 16.4938 29.5 20.0556 29.5H21.9444C25.5062 29.5 27.287 29.5 28.3935 28.551C29.5 27.6021 29.5 26.0747 29.5 23.02V20",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14L24.9117 13.6909C24.4717 12.1509 24.2517 11.3809 23.7279 10.9404C23.2041 10.5 22.5084 10.5 21.117 10.5H20.883C19.4916 10.5 18.7959 10.5 18.2721 10.9404C17.7483 11.3809 17.5283 12.1509 17.0883 13.6909L17 14",
    stroke: "#FF6600",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagor);
export default __webpack_public_path__ + "static/media/bagor.d345dec23adbef565d7371e49f1c2f9b.svg";
export { ForwardRef as ReactComponent };